import { Component, OnInit, Input } from '@angular/core';
import { WalletService } from 'src/app/services/api/wallet.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {

	@Input() page:string = '';

	constructor(
		public walletService: WalletService
	) { }

	ngOnInit(): void {
		this.walletService.getWallet();
	}

}
